export default __webpack_public_path__ + "static/media/robot-pfp.ff51f852.svg";